import React, { useState } from 'react';

import styled from '@emotion/styled';

import { FormSubmitBtn } from '../../../../components/Button/FormSubmitButton';
import { Modal } from '../../../../components/Modal/Modal';
import ChangePasswordModal from '../../../../components/Modal/ModalActions/ChangePasswordModal/ChangePasswordModal';

const ChangePassword = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Box>
        <BoxTextArea>
          <BoxBoldText>Change Password</BoxBoldText>
          <BoxText>Set a unique password to protect your account</BoxText>
        </BoxTextArea>
        <FormSubmitBtn
          onClick={() => setShowModal(true)}
          type='button'
          className='fit'
        >
          Change password
        </FormSubmitBtn>
      </Box>
      <Modal showModal={showModal} setShowModal={setShowModal}>
        <ChangePasswordModal />
      </Modal>
    </>
  );
};

export default ChangePassword;

const Box = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 28px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background-color: #fff;
`;

const BoxTextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const BoxBoldText = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const BoxText = styled.div`
  gap: 20px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
  font-weight: 500;
`;
